import { RuntimeModel, http } from '@kunlun/dependencies';
import { graphqlQueryFormatter, stringifyToGraphql } from '../../../../utils/serialize';

export const queryPromotionType = async (rModel: RuntimeModel) => {
  const gql = `
       query {
	    deliAriesSellerPromotionPlanQuery {
		queryPromotionTypeEnumList(data: {}) {
			promotionTypeEnumList {
				displayName
				name
				value
			}
		}
	    }
    }

      `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));
  return res?.data?.deliAriesSellerPromotionPlanQuery?.queryPromotionTypeEnumList;
};
